@use "Styles/mixins";

:host {
    display: inline-flex;

    // Desktop renders the comments organism inline below the player, so the
    // mobile sheet trigger is hidden there.
    @include mixins.desktop-and-up {
        display: none;
    }
}
